module.exports = __webpack_public_path__ + "static/media/studio-pro-offer.424ada99.png";